export var SerialiseType;
(function (SerialiseType) {
    /** Property will always be serialised / deserialised */
    SerialiseType[SerialiseType["Always"] = 0] = "Always";
    /**
     * Property will only be deserialised on a full deserialise or when being mapped. E.g. using set() and not update(), or if the object is created during deserialisation.
     * Use this on non mapped properties where the data will only be transferred on an initial get.
    */
    SerialiseType[SerialiseType["FullOnly"] = 1] = "FullOnly";
    /** Property will be serialised when its value is not null. */
    SerialiseType[SerialiseType["NotNull"] = 2] = "NotNull";
    /** Property will only be deserialised when being mapped. */
    SerialiseType[SerialiseType["MappingOnly"] = 3] = "MappingOnly";
    /** Property will never be serialised / deserialised */
    SerialiseType[SerialiseType["Never"] = 4] = "Never";
})(SerialiseType || (SerialiseType = {}));
export var TimeZoneFormat;
(function (TimeZoneFormat) {
    /** Date will be serialised as UTC with Z */
    TimeZoneFormat[TimeZoneFormat["UTC"] = 1] = "UTC";
    /** Date will be serialised without time zone info. */
    TimeZoneFormat[TimeZoneFormat["None"] = 2] = "None";
})(TimeZoneFormat || (TimeZoneFormat = {}));
export var RelationType;
(function (RelationType) {
    RelationType[RelationType["None"] = 0] = "None";
    RelationType[RelationType["ChildObject"] = 1] = "ChildObject";
    RelationType[RelationType["ChildList"] = 2] = "ChildList";
    RelationType[RelationType["Parent"] = 3] = "Parent";
    RelationType[RelationType["ValueObject"] = 4] = "ValueObject";
    RelationType[RelationType["Dictionary"] = 5] = "Dictionary";
})(RelationType || (RelationType = {}));
export var DataType;
(function (DataType) {
    DataType[DataType["String"] = 1] = "String";
    DataType[DataType["Int"] = 2] = "Int";
    DataType[DataType["Float"] = 3] = "Float";
    DataType[DataType["Date"] = 4] = "Date";
    DataType[DataType["Object"] = 5] = "Object";
    DataType[DataType["Array"] = 6] = "Array";
    DataType[DataType["NullableBoolean"] = 7] = "NullableBoolean";
    DataType[DataType["Decimal"] = 8] = "Decimal";
})(DataType || (DataType = {}));
var OnChangedOptions = /** @class */ (function () {
    function OnChangedOptions(onChangedFn, requiresOldValue, delayMs) {
        this.onChangedFn = onChangedFn;
        this.requiresOldValue = requiresOldValue;
        this.delayMs = delayMs;
    }
    return OnChangedOptions;
}());
export { OnChangedOptions };
export var TrackingState;
(function (TrackingState) {
    TrackingState[TrackingState["Unchanged"] = 0] = "Unchanged";
    TrackingState[TrackingState["Added"] = 1] = "Added";
    TrackingState[TrackingState["Modified"] = 2] = "Modified";
    TrackingState[TrackingState["Deleted"] = 3] = "Deleted";
})(TrackingState || (TrackingState = {}));
